import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/ppi/hh-audit";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

// Sessions
const getList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/sessions`, params));
const find = (id: number) => handle(http.getData(`${BASE}/sessions/${id}`));
const create = (data: any) => handle(http.postData(`${BASE}/sessions`, data));
const update = (id: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${id}`, data));
const destroy = (id: number) =>
  handle(http.deleteData(`${BASE}/sessions/${id}`));

// Katalog item checklist blanko (sumber tunggal teks item)
const catalog = () => handle(http.getData(`${BASE}/catalog`));

// Checklist blanko (upsert hasil Ya/Tidak + keterangan per item)
const saveItems = (sessionId: number, items: any[]) =>
  handle(http.putData(`${BASE}/sessions/${sessionId}/items/bulk`, { items }));

// Sign (3-tier: Auditor PPI -> Ka. Unit -> Komite PPI/Manajer Mutu)
const submitAuditor = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/submit-auditor`, data));
const approveKaunit = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/approve-kaunit`, data));
const approveKomitePpi = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/approve-komite-ppi`, data));

// Dashboard
const getDashboard = (params?: any) =>
  handle(http.getDataParam(`${BASE}/dashboard`, params));

// PDF
const printPdf = (id: number) => {
  window.open(`${http.getAPI()}${BASE}/sessions/${id}/pdf`, "_blank");
};

export default {
  getList,
  find,
  create,
  update,
  destroy,
  catalog,
  saveItems,
  submitAuditor,
  approveKaunit,
  approveKomitePpi,
  getDashboard,
  printPdf
};
